import { Roster } from "model/Roster/Roster";
import {
  WorldTourScoring,
  getWorldTourRoundPoints,
} from "model/Match/Set/WorldTour/Format/WorldTourScoring";
import { WorldTourRound } from "model/Match/Set/WorldTour/Track/WorldTourRound";
import { WorldTourRoundResult } from "model/Match/Set/WorldTour/Track/WorldTourRoundResult";
import { TrackRound } from "model/Match/Track/TrackRound";
import { RosterScope } from "model/Roster/RosterScope";

export const mapWorldTourRounds = (
  baseRounds: TrackRound[],
  rosters: Roster[],
  rosterScope: RosterScope,
  scoring: WorldTourScoring,
  driversPerTeam: number
) => {
  return baseRounds.map((r) =>
    mapWorldTourRound(r, rosters, rosterScope, scoring, driversPerTeam)
  );
};

const mapWorldTourRound = (
  base: TrackRound,
  rosters: Roster[],
  rosterScope: RosterScope,
  scoring: WorldTourScoring,
  driversPerTeam: number
): WorldTourRound => {
  const numDrivers = driversPerTeam * rosters.length;
  const roundPoints =
    base.times.length >= numDrivers
      ? getWorldTourRoundPoints(scoring, base.times, rosters, rosterScope)
      : undefined;

  const results: WorldTourRoundResult[] = [];
  if (!!roundPoints) {
    Object.keys(roundPoints).forEach((rosterId) =>
      results.push({ rosterId, points: roundPoints[rosterId] })
    );
  }

  return {
    ...base,
    results,
  };
};
